import React, { useContext, Fragment } from 'react';
import { withStyles, Grid } from '@material-ui/core';
import DataContext from '../../data/DataContext';

const styles = (theme) => ({
  root: {
    display: 'flex',
    // letterSpacing: "-0.5px",
    fontWeight: '300',
    marginTop: '6px',
  },
  leftContainer: {
    justifyContent: 'flex-start',
  },
  rightContainer: {
    justifyContent: 'flex-end',
  },
  message: {
    fontSize: theme.font.size14,
    borderRadius: '10px',
    flexWrap: 'wrap',
    color: theme.color.message.color,
    backgroundColor: theme.color.message.background,
    lineHeight: '1.43',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: 'normal',
    padding: '12px 16px',
    width: '16.25rem',
    wordWrap: 'break-word',
    wordBreak: 'normal',
  },
  leftMessage: {
    margin: '0 16px 6px 16px',
  },
  rightMessage: {
    margin: '26px 10px',
    boxShadow: 'none',
  },
  gridContainer: {
    width: '100%',
    display: 'flex',
    margin: '12px 0px',
  },
  buttonRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'stretch',
    margin: '6px 16px',
  },
  buttonContainer: {
    fontWeight: 'bold',
    display: 'flex',
    margin: '0 4px 8px 0',
  },
  buttonItem: {
    width: '100%',
    padding: '8px 14px 9px 14px',
    background: theme.color.button.background_white,
    border: '0',
    fontSize: theme.font.size13,
    borderRadius: '1.5rem',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineSpacing: 'normal',
    // outline: "0 none",
    '&:active': {
      background: '#ccc',
    },
    color: theme.color.button.label_sg,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
  },
  '@media screen and (max-width:767px)': {
    message: {
      width: '100%',
    },
  },
});

const GridButtonsRaw = (props) => {
  const { classes, data } = props;
  const context = useContext(DataContext);

  const handleClick = (button) => {
    context.request(context, button.speech, 'button');
  };
  return (
    !context.conversationEnd && (
      <>
        <Grid container className={classes.buttonRow} direction="row">
          {data.buttons.map((button, key) => (
            <Grid item key={key} className={classes.buttonContainer}>
              <button
                type="button"
                className={classes.buttonItem}
                onClick={() => handleClick(button)}
                aria-label={`${button.label}, ${key + 1} / ${data.buttons.length}`}
              >
                {button.label}
              </button>
            </Grid>
          ))}
        </Grid>
      </>
    )
  );
};
const GridButtons = withStyles(styles)(GridButtonsRaw);
function SGVertical(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);

  return (
    <>
      {data.text && data.text !== '' && (
        <div
          className={[
            classes.root,
            data.mine ? classes.rightContainer : classes.leftContainer,
          ].join(' ')}
          role={'text'}
          tabIndex={0}
          aria-label={`${context.string.aria.chatbotMessage} ${data.text}`} /*, ${moment(data.date, "LT").format("A hh시 mm분")}`}*/
        >
          <p
            className={[
              classes.message,
              data.mine ? classes.rightMessage : classes.leftMessage,
            ].join(' ')}
          >
            {data.text.split('\n').map((content, key) => (
              <Fragment key={key}>
                {content}
                <br />
              </Fragment>
            ))}
          </p>
        </div>
      )}
      {data.isLast && <GridButtons className={classes.gridContainer} data={data} />}
    </>
  );
}
export default withStyles(styles)(SGVertical);
